/**
 * Single source of truth for every business fact on the site.
 *
 * Anything marked NEEDS-CONFIRMATION was not supplied in the brief. It is
 * rendered from here so the client can correct it in one place — nothing in
 * this file is invented from thin air, and unverified claims are kept out of
 * the marketing copy entirely.
 */

export const site = {
  legalName: 'Rajendra Jewellers Pvt. Ltd.',
  shortName: 'Rajendra Jewellers',
  descriptor: 'Gold, Diamond & Branded Jewellery',
  credential: 'Govt. Approved Valuer',
  tagline: 'A Place Where People Trust',
  url: 'https://rajendraajewellers.com/',

  // Disciplines as they appear on the company mark.
  disciplines: ['Gold & Diamond Jewellery', 'Gold Antique Jewellery', 'Branded Jewellery'],

  contact: {
    phone: '9978875442',
    phoneDisplay: '+91 99788 75442',
    phoneHref: 'tel:+919978875442',
    whatsappHref: 'https://wa.me/919978875442',
    // NEEDS-CONFIRMATION: supplied as RAJEDRAA_JEWELLERS_PVTLTD@YAHOO.COM.
    // The spelling differs from the company name; kept verbatim pending review.
    email: 'rajedraa_jewellers_pvtltd@yahoo.com',
  },

  address: {
    line1: '6-G/103, C G Road',
    line2: 'Opp. Lal Bunglow',
    city: 'Ahmedabad',
    state: 'Gujarat',
    postalCode: '380006',
    country: 'India',
    full: '6-G/103, C G Rd, opp. Lal Bunglow, Ahmedabad, Gujarat 380006',
    mapsHref:
      'https://www.google.com/maps/search/?api=1&query=Rajendra+Jewellers+6-G%2F103+C+G+Road+opp+Lal+Bunglow+Ahmedabad+380006',
    mapsEmbed:
      'https://www.google.com/maps?q=Rajendra+Jewellers+6-G/103+C+G+Road+opp+Lal+Bunglow+Ahmedabad+380006&output=embed',
  },

  social: {
    instagram: 'https://www.instagram.com/rajendrajewellersofficial/?hl=en',
    instagramHandle: '@rajendrajewellersofficial',
  },

  // Website credit, shown in the footer.
  credit: {
    label: 'Developed by',
    name: 'Shreepati Systems',
    url: 'https://www.shreepatisystems.com/',
  },

  // NEEDS-CONFIRMATION: trading hours were not supplied in the brief.
  hours: [
    { days: 'Monday – Saturday', time: '11:00 am – 8:00 pm' },
    { days: 'Sunday', time: 'By appointment' },
  ],
  hoursConfirmed: false,
};

/**
 * Service promises. Each of these is either printed on the company mark or is
 * a plain description of what the showroom does — no certifications, awards or
 * founding dates are claimed here.
 */
export const services = [
  {
    title: 'Government Approved Valuation',
    body: 'Formal jewellery valuation carried out in-house by a Govt. Approved Valuer, for insurance, probate and finance.',
    icon: 'seal',
  },
  {
    title: 'Gold & Diamond Jewellery',
    body: 'Everyday gold, diamond and CZ pieces alongside statement sets, selected and fitted with you at the counter.',
    icon: 'gem',
  },
  {
    title: 'Gold Antique Jewellery',
    body: 'Temple work, kundan, polki and antique-finish gold — the traditional craft the showroom is known for.',
    icon: 'crown',
  },
  {
    title: 'Branded Jewellery',
    body: 'Branded lines and timepieces held in store, so you can compare them beside our own collections.',
    icon: 'tag',
  },
];

export default site;
